export default {
  TITLE: '使用条件',
  CONTENT: `
  <h3>最近更新：2023年11月16日</h3>
  <p>
    欢迎访问www.amazon.cn（“本网站”）。本网站的网络运营服务及其它亚马逊服务（定义见下文）所包括的产品和服务由亚马逊卓越有限公司及其关联公司（包括北京世纪卓越信息技术有限公司)（“亚马逊”
    或“我们”）向您提供。亚马逊服务指您访问本网站或在本网站购物、使用亚马逊产品或服务、使用亚马逊的移动客户端、或者使用亚马逊提供的与前述任一项相关的软件时亚马逊向您提供的产品和服务。除非商品详情页面明确说明，否则本网站上商品由北京世纪卓越信息技术有限公司，且该等商品描述以及其它内容中的“亚马逊”均指北京世纪卓越信息技术有限公司（注册信息）。亚马逊基于以下条件提供亚马逊服务。
  </p>
  <p>使用亚马逊服务即表明您同意本使用条件，请仔细阅读这些使用条件。</p>
  <p>
    我们向您提供不同类型的亚马逊服务。在一些情况下，除遵守本使用条件外，您还需要遵守额外的条款。您使用一项亚马逊服务（例如，我的帐户、礼品卡、亚马逊设备、或亚马逊应用）时，您同时应接受适用于那些服务的使用条件、准则、条款和协议（以下统称为“服务条款”）。如果本使用条件与服务条款有不一致之处，则以服务条款为准。
  </p>
  <h3>隐私</h3>
  <p>
    请阅读我们的隐私声明以了解我们的惯例。该声明也适用于您对亚马逊服务的使用。
  </p>
  <h3>电子通讯</h3>
  <p>
    当您使用亚马逊服务或者从您的台式电脑或移动设备给我们发送电子邮件、短信、及其它通讯，您可能正与我们进行电子通讯。您同意接收我们发给您的电子通讯信息，比如电子邮件、短信、手机的推送通知、
    或本网站上或其它的亚马逊服务（比如我们的消息中心）发布通知和消息，且可以为您自己的记录保留这些通讯信息的副本。您同意我们用电子方式提供给您的所有协议、通知、披露和其他信息均符合任何要求该等通讯应该是书面形式的法律法规的规定。
  </p>
  <h3>版权</h3>
  <p>
    亚马逊服务所包含或提供的所有内容诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件都是亚马逊或其内容提供者的财产，
    受中国和国际版权法的保护。亚马逊服务中包含的或通过亚马逊服务提供的所有内容的编译都是亚马逊的独有财产，受中国和国际版权法的保护。
  </p>
  <h3>商标权利</h3>
  <p>
    <a data-path="protocol" data-title="TRADEMARK">请点击此链接访问非完全的亚马逊商标清单</a>。另外，亚马逊服务所包含或者提供的图表、标识、页眉、按钮图标、文字、服务品名均为亚马逊在中国和其它国家的商标或商业外观。
    亚马逊的商标或商业外观不得以任何可能引起消费者混淆的方式或任何诋毁或诽谤亚马逊的方式用于与本网站或其关联公司无关联的任何商品或服务上。亚马逊服务的其他商标是其商标权利人各自的财产，这些权利人可能隶属于亚马逊、与亚马逊相关或由亚马逊赞助，也可能不是。
  </p>
  <h3>专利</h3>
  <p>
    亚马逊拥有的一个或多个专利适用于亚马逊服务及通过亚马逊服务获得的功能和服务。部分亚马逊服务在一个或多个专利许可下运行。<a data-path="https://www.amazon.com/gp/help/customer/display.html/?nodeId=200204190">请点击此链接访问相关的亚马逊专利和相关的许可专利的非完全清单</a>。
  </p>
  <h3>商品合规</h3>
  <p>
    由北京世纪卓越信息技术有限公司或在中国大陆（即，不包括香港特别行政区、澳门特别行政区和台湾）境内注册成立的第三方卖家销售的商品及其售后服务均受中国人民共和国法律管辖。
    在本网站上展示的有些商品可能是由位于中国大陆（即，不包括香港特别行政区、澳门特别行政区和台湾）以外的卖家直接销售和配送的，并适用于相关服务条款，比如
    <a data-path="termStatement" data-title="USE_CONDITION_FOR_AGS" >亚马逊海外购使用条件</a>。
    这些进口商品均受商品原销售目的地法律管辖，而该等法律有可能与中国法规的要求不同，比如在语言、商品包装和标识、商品信息披露等方面。这些商品在其相关的商品详情页面均已被标注为进口商品。
    在您选择购买和进口这些进口商品自用时，请注意这些差别。
  </p>
  <h3>许可和网站进入</h3>
  <p>
    如您遵守本使用条件和任何服务条款并支付应付费用，我们或内容提供商对您对本网站的访问和个人且非商业使用亚马逊服务授予有限许可，该许可为非排他的、不可转让的且不可再许可的许可。
    这一许可不包括以下内容：任何对亚马逊服务或其内容的再销售或商业使用；任何对商品目录、说明或价格的收集和使用；任何对亚马逊服务或其内容的衍生利用；为任何第三方利益的任何下载、
    拷贝帐户信息或对账户信息的其它使用；或者任何数据采集、网络爬虫或类似的数据收集和摘录工具的使用。本使用条件或服务条款没有明确许可您的所有权利均为亚马逊或其许可方、供应商、出版商、
    权利所有人、或其它内容提供方保留和所有。未经亚马逊明确书面同意，不得以任何商业目的对亚马逊服务或其任何部分进行转载、复制、拷贝、出售、转售、访问或以其他方式加以利用。
    未经亚马逊明确书面同意，您不得用框架或运用框架技术附上本网站的商标、标识或其他专有信息（包括图像、文字、网页设计或形式）。未经亚马逊明确书面同意，
    您不得以任何原标记或任何其他"隐藏文本"方式使用我们的名字或商标。您不得滥用亚马逊服务。您仅可在法律允许的情况下使用亚马逊服务。如果您未遵守本使用条件或任何服务条款，则亚马逊在此的授权即时终止。
  </p>
  <h3>您的账户</h3>
  <p>
    您需要一个您自己的亚马逊账户以使用某些亚马逊服务，且您需要登陆您的账户并在该账户下绑定一个有效支付方式。如果您选择的支付方式有问题，我们会通过您账户绑定的其他有效支付方式进行扣款。
    您应负责维护您的帐户和密码的保密性并限制第三方使用/访问您的账户，并且，您同意对在您的帐户和密码下发生的所有活动承担责任。亚马逊销售供儿童使用的商品，但我们仅向具有支付能力的成年人销售这些商品。
    如果您未满18周岁，您只能在父母或监护人的参与下使用亚马逊服务。亚马逊提供的酒类产品仅销售给成年人。亚马逊保留自行决定拒绝提供服务、关闭帐户、终止您使用亚马逊服务的权利、删除或编辑内容或取消订单的权利。
  </p>
  <h3>禁止代购销售</h3>
  <p>
    亚马逊着眼于向终端消费者的业务拓展，因此不允许代购销售。代购是指客户的主要或者重要的业务通过购买亚马逊的商品并将其转售给其直接客户的行为。如果亚马逊发现您的帐户中有转售从亚马逊购买的商品的记录，
    我们将不再允许此帐户购买商品，并有可能永久地关闭您在亚马逊的该帐户。
  </p>
  <h3>评论、意见、信息交流和其他内容</h3>
  <p>
    您可以发布评论、意见、图片和其他内容，以及提出建议、想法、意见、问题或其他信息，前提是其内容不是非法、淫秽、威胁、诽谤、侵犯隐私、侵犯知识产权（包括公开权）或以其他形式对第三方构成伤害、侵犯或引起公众反感，
    也不包含软件病毒、政治宣传、商业招揽、连锁信、大宗邮件或任何形式的“垃圾邮件”或未经要求的商业电子信息。您不得使用虚假的电子邮件地址、手机号码、冒充任何他人或实体，或以其它方式对卡片或其他内容的来源进行误导。
    本网站保留清除或编辑这些内容的权利（但非义务），但不对发布的内容进行定期的审查。
  </p>
  <p>
    如果您发布内容或提交材料，除非我们另行说明，您同意授予我们非独有的、免费的、永久的、不可撤销的和完全的再许可权的下述许可：在全世界范围内任何媒体上使用、转载、修改、改编、出版、翻译、创作衍生作品、分发和展示这些内容。
    您授予我们和许可受让人根据需要使用您所提交的与这些内容有关的名字的权利。您声明并保证：您对所发布的内容拥有所有权或以其它方式对相关权利拥有控制权；发布的内容是准确的；
    对您所提供内容的使用不违反本政策并不会对任何个人和实体造成伤害；并且您将对于因您所提供的内容引起的对亚马逊的损害进行赔偿。我们有权（但非义务）监控和编辑或清除任何活动或内容。我们对您或任何第三方所发布的内容不承担责任。
  </p>
  <h3>知识产权投诉</h3>
  <p>
    亚马逊尊重他人的知识产权。如果您认为您的知识产权（比如版权或商标权利等）受到了侵犯，请填写通知表格向我们提供涉嫌侵权的相关信息。我们会尽快对权利人有关其权利可能受到的任何侵害予以回复。
  </p>
  <h3>货物灭失</h3>
  <p>
    所有在本网站订购的实物商品由我们通过承运商进行配送。因此，该商品的所有权及灭失风险自我们将其交付给承运商时转移给您。
  </p>
  <h3>合同缔结</h3>
  <p>
    如果您通过本网站订购商品，本网站上展示的商品和价格等信息仅仅是要约邀请，您的订单将成为订购商品的要约。当您作为消费者为生活消费需要下单并支付货款的情况下，您货款支付成功后即视为我们与您之间的订购合同就已支付货款部分商品成立。
  </p>
  <h3>退货、退款及所有权</h3>
  <p>
    亚马逊在货物抵达亚马逊库房前对退回的货物不享有所有权。亚马逊可自主选择在不要求退货的前提下进行退款，在这种情况下，亚马逊对退回的货物不享有所有权。如需了解更多的退货及退款信息，请参看我们的<a data-path="asList">退货中心</a>。
  </p>
  <h3>商品信息</h3>
  <p>
    我们努力使商品信息尽可能准确。但是，我们并不保证商品信息或本网站服务的其他内容是准确的、完整的、可靠的、最新的或无误的。如果我们提供的商品与本网站上商品描述不一致，您唯一的救济是将该未经使用过的商品退还我们。
  </p>
  <h3>价格及其他因素</h3>
  <p>
    除非另有规定，在本网站上显示的图书产品的定价和非图书类产品的厂商建议零售价是我们根据生产商或供应商提供的价格信息展示在网站上的参考价格。当商品由第三方卖家销售时，商品的参考价格由该第三方卖家根据亚马逊对第三方卖家的相关要求提供。
  </p>
  <p>
    对于由亚马逊销售的商品，直到您发出订单并经我们确认发货，我们才能确认该商品的售价。尽管我们尽最大的努力，但是由于技术障碍以及各类因素，我们的商品目录里的一小部分商品可能偶尔会有定价错误、商品无货、或其他我们难以控制和避免的情况。
    如果某一商品出现前述情形，我们有权根据具体情况决定在发货前联系您咨询您的意见,或者取消您的订单并通知您。
  </p>
  <p>
    请注意，本价格及其他因素政策仅适用于由亚马逊销售和配送的商品。对于您从第三方卖家购买的商品，系统会根据该卖家在亚马逊选择的服务、在您下订单时提示可支持的支付方式；并且，对于错误标价、商品无货、
    或其他第三方卖家难以控制和避免的情况，第三方卖家有可能遵循不同的政策。
  </p>
  <h3>软件应用许可</h3>
  <p>
    当您使用亚马逊的应用软件时，比如亚马逊移动客户端或者Kindle阅读软件，您授予我们您设备的一些许可。大部分移动设备均向您提供有关该等许可的信息。获得更多这些许可的信息，点击
    <a data-path="https://www.amazon.com/gp/help/customer/display.html/?nodeId=201818880">这里</a>。
  </p>
  <h3>制裁及出口政策</h3>
  <p>
    如果您受制于美国的制裁，或受制于您正在使用的亚马逊服务所在地之国家政府施行的、与美国法律一致的制裁，您可能无法使用任何亚马逊服务。您必须遵守可能对商品、软件（包括亚马逊软件）、技术及服务所适用的美国或其他国家的所有出口及再出口限制。
  </p>
  <h3>其他企业</h3>
  <p>
    除亚马逊之外的其他第三方卖家通过亚马逊服务开店、提供服务或软件、或者销售商品。另外，我们提供连接到关联公司和其他企业网站的链接。我们不负责审查和评估也不担保任何企业或个人（包括它们网站的内容）的待售商品。
    我们对所有这些企业或任何其他第三人或其网站的行为、商品和内容不承担责任。您应仔细阅读其使用条件及隐私政策。
  </p>
  <h3>担保和责任限制的免责声明</h3>
  <p>
    除非另有明确的书面说明，亚马逊服务及其所包含的或以其它方式通过亚马逊服务提供给您的全部信息、内容、材料、商品（包括软件）和其他服务，是在“现状”和“现存”的基础上提供的。除非另有明确的书面说明，我们不对亚马逊服务的运营及包含在亚马逊服务内的信息、
    内容、材料、商品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的除外）。您明确同意自担风险使用亚马逊服务。
  </p>
  <p>
    在法律所允许的最大限度内，我们不承诺所有明示或默示的担保，包括但不限于对适销性和满足特定目的的默示担保。我们不担保亚马逊服务、其所包含的或以其它方式通过亚马逊服务提供给您的全部
    信息、内容、材料、商品（包括软件）和服务、其服务器或从本网站发出的电子信件没有病毒或其他有害成分。在法律所允许的最大限度内，除非另有明确的书面说明，我们不对由于使用亚马逊服务、或由于其所包含的或以其它方式通过亚马逊服务提供给您的全部信息、
    内容、材料、商品（包括软件）和服务、或购买和使用产品引起的任何损害承担责任（除非根据中华人民共和国法律应承担责任的以外），包括但不限于直接、间接或附带的惩罚性和结果性的损害赔偿。
  </p>
  <h3>适用法律</h3>
  <p>
    通过使用任何亚马逊服务，您同意本使用条件以及您和本网站之间发生的任何争议均适用中华人民共和国法律（服务条款另行规定的情形除外）。
  </p>
  <h3>争议</h3>
  <p>
    有关与您使用任何亚马逊服务或与通过本网站由北京世纪卓越信息技术有限公司销售的商品或服务相关的任何形式的任何争议或主张应提交北京市有管辖权的法院诉讼解决（服务条款另行规定的情形除外）。
  </p>
  <h3>网站政策、修改和可分性</h3>
  <p>
    请阅读本网站上发布的其他政策。这些政策同样适用于您对亚马逊服务的使用。我们保留在任何时候对本网站、政策、服务条款和本使用条件作出修改的权利。如果本使用条件中任何一条被视为废止、
    无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。
  </p>
  <h3>额外的亚马逊软件使用条款</h3>
  <p>
    以下条款（“软件条款”）适用于任何我们提供给您的与亚马逊服务相关的软件（包括软件的任何更新或升级）及任何相关文件（“亚马逊软件”）。
  </p>
  <ul class="number-format">
    <li>
      亚马逊软件的使用：您只可以为您使用和享受亚马逊提供的亚马逊服务之目的使用亚马逊软件，并且该等使用应遵守本使用条件、软件条款及任何服务条款。您不得将亚马逊软件的任何部分合并到其它程序中，
      或结合其它程序编辑亚马逊软件的任何部分，或对亚马逊软件全部或副本进行复制（除行使本条赋予的权利）、修改、生成衍生作品、分发、转让任何权利、或许可。
      所有亚马逊服务使用的软件为亚马逊或其软件供应商的财产，受中国及国际版权相关法律的保护。
    </li>
    <li>
      第三方服务的使用 在您使用亚马逊软件时，您可能同时使用一家或多家第三方的服务，例如无线网络服务商或者移动软件服务商。当使用这些第三方的服务时，您应遵守这些第三方的政策、使用条件以及相关费用的规定。
    </li>
    <li>
      禁止反向工程 您不得鼓励、协助或授权任何其他人复制、修改、反向工程、反向编译或反汇编、拆解或者试图篡改全部或部分的亚马逊软件，或利用亚马逊软件创设衍生产品。
    </li>
    <li>
      软件更新 我们可在未通知您的情况下随时对亚马逊软件自动更新或者手动更新。
    </li>
    <li>
      冲突 在本使用条件和任何其它适用于亚马逊软件任何部分的亚马逊或第三方条款（比如开放源码授权条款）有冲突的情况下，就该等冲突以及涉及亚马逊软件的部分，以该等其它条款为准。
    </li>
  </ul>
  `
};
